// JavaScript Document

import React from "react";
import '../styles/global.css'

export default function HalfWidthImage(props) {
    return  (
        
        
        
                <div class="col-10 offset-1 col-md-6 offset-md-0 bannerBlock" id={props.id}>
        
                    <img  src={props.src} alt={props.alt}></img>
        
                </div>        
        
            
        
    );
    
}
